import { Component, OnInit } from '@angular/core';
import { GlobalSearchService, StorageService } from 'src/services';
import { NavigationService } from 'src/services/navigation.service';

@Component({
  selector: 'app-terminology',
  templateUrl: './terminology.component.html',
  styleUrl: './terminology.component.scss'
})
export class TerminologyComponent implements OnInit {
  terminologyList = [
    { term: 'API', definition: 'Application Programming Interface' },
    { term: 'Angular', definition: 'A framework for building SPAs' },
    { term: 'Component', definition: 'A fundamental UI building block in Angular' },
  ];
  filteredTerminology = [...this.terminologyList];
  activeTerm: any = 'Market Benchmarks'
  constructor(private navigationService: NavigationService, private globeSearch: GlobalSearchService, private searchService: GlobalSearchService, private storage: StorageService) {
    // this.navigationService.activeTerm$.subscribe(term => {
    //   this.activeTerm = term;
    // });

    if (this.storage.getData()) {
      this.activeTerm = this.storage.getData();
    }
  }

  ngOnInit() {
    this.navigationService.activeTerm$.subscribe(value => {
      this.activeTerm = value;
    });

    this.searchService.searchQuery$.subscribe(query => {
      this.filteredTerminology = this.terminologyList.filter(item =>
        item.term.toLowerCase().includes(query.toLowerCase())
      );
    });
  }

  makeActive(path) {
    this.activeTerm = path;
  }
}
